var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJackpottag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 22,
    viewBox: "0 0 46 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H42C44.2091 0 46 1.79086 46 4V18C46 20.2091 44.2091 22 42 22H4C1.79086 22 0 20.2091 0 18V4Z",
    fill: "white",
    fillOpacity: 0.79
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H42C44.2091 0 46 1.79086 46 4V18C46 20.2091 44.2091 22 42 22H4C1.79086 22 0 20.2091 0 18V4Z",
    fill: "#8130EC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H42C44.2091 0 46 1.79086 46 4V18C46 20.2091 44.2091 22 42 22H4C1.79086 22 0 20.2091 0 18V4Z",
    fill: "url(#paint0_linear_16504_6346)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H42C44.2091 0 46 1.79086 46 4V18C46 20.2091 44.2091 22 42 22H4C1.79086 22 0 20.2091 0 18V4Z",
    fill: "url(#paint1_radial_16504_6346)",
    fillOpacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16504_6346",
    x1: 23,
    y1: 0.00000239951,
    x2: 23,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_16504_6346",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23 3.83906) rotate(90) scale(18.1609 23)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpottag);
export default __webpack_public_path__ + "static/media/jackpottag.913a85a9e365a132eaef6c48516941ad.svg";
export { ForwardRef as ReactComponent };